import { updateTag } from '../../services/tags/TagsService';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GET_TAGS_KEYS } from '../../query/tags/keys';
import { TagsResponse } from '../../../models/tags/TagsResponse';
import { GET_ALL_COMMON_KEYWORDS, GET_COMMON_KEYWORDS } from '../../query/keyword/keys';
import { GET_PROJECT_MONITORS } from '../../query/monitor/keys';
import {
  GET_PROJECT_ALL_BRANDS_RESPONSE,
  GET_PROJECT_DAILY_STATS,
} from '../../query/project/stats/keys';
import { GET_KEYWORDS_DAILY_STATS_FOR_PROJECT } from '../../query/keyword/stats/keys';

export const useUpdateTags = (projectId: number) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (tagData: Partial<TagsResponse>) => updateTag(tagData),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_TAGS_KEYS, projectId],
      });
      queryClient.invalidateQueries({
        queryKey: [GET_COMMON_KEYWORDS, projectId],
      });
      queryClient.invalidateQueries({
        queryKey: [GET_KEYWORDS_DAILY_STATS_FOR_PROJECT, projectId],
      });
      queryClient.invalidateQueries({
        queryKey: [GET_PROJECT_DAILY_STATS, projectId],
      });
      queryClient.invalidateQueries({
        queryKey: [GET_PROJECT_ALL_BRANDS_RESPONSE, projectId],
      });
      queryClient.invalidateQueries({
        queryKey: [GET_ALL_COMMON_KEYWORDS, projectId],
      });
      queryClient.invalidateQueries({
        queryKey: [GET_PROJECT_MONITORS, projectId],
      });
    },
  });

  return mutation;
};
